import { useMemo } from 'react';
import {
    MaterialReactTable,
    MRT_Cell,
    useMaterialReactTable,
    type MRT_ColumnDef,
    type MRT_TableOptions,
} from 'material-react-table';
import { Typography, useMediaQuery } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

interface CustomReport {
    date_time: string;
    deviceId: string;
    vehicle: string;
    lastVideoLoc: string;
    lastLatitude: string;
    lastLongitude: string;
    totalKmToday: number;
    totalTripKm: number;
    eta: string;
    cta: string;
    totalEventsCount: number;
    overspeedingCount: number;
    farwardCollisionCount: number;
    laneDeparterCount: number;
    pedestarianCount: number;
    continiuosDrivingCount: number;
    nightDrivingCount: number;
    sosEventCount: number;
    distractedCountVp1: number;
    callToCallCountVp1: number;
    smokingCountVp1: number;
    drowsinessCountVp1: number;
    yawingCountVp1: number;
    driverWithoutSeatBeltCount: number;
    harshaccelerationFcwCount: number;
    hardBrakingFcwCount: number;
    harshTurningFcwCount: number;
    suddenStoppageCount: number;
}

const data: CustomReport[] = []

export default function CustomReportPreview({ data, onClose }: { data: any, onClose: () => void }) {   
    console.log('scbkjscnksncksnck', data) 
    const isSmallScreen = useMediaQuery("(max-width:850px)");

    const formatColumnLabel = (column: string) => {
        return column
            .replace(/([A-Z])/g, ' $1')
            .replace(/(Count|Vp1|Fcw|Km)/g, ' $1')
            .replace(/^./, str => str.toUpperCase())
            .trim()
            .replace(/ Count$/, '')
            .replace(/ Vp1$/, '')
            .replace(/ Fcw$/, '');
    };

    const myColumns: MRT_ColumnDef<CustomReport>[] = useMemo(() => {
        if (!data?.selectedColumns) return [];

        return data.selectedColumns.map((column: string) => ({
            accessorKey: column,
            header: formatColumnLabel(column),
            enableColumnActions: false,
            size: isSmallScreen ? 90 : 220,
            muiTableBodyCellProps: {
                sx: {
                    maxWidth: '200px',
                    padding: '8px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            Cell: ({ cell }: { cell: MRT_Cell<CustomReport> }) => (
                <Typography variant="body2" fontWeight={400} noWrap>
                    {cell.getValue<string>() || '-'}
                </Typography>
            )
        }));
    }, [data?.selectedColumns, isSmallScreen]);

    const tableOptions: MRT_TableOptions<CustomReport> = {
        columns: myColumns,
        data: [],
        enablePagination: false,
        enableColumnFilters: false,
        enableSorting: false,
        enableGlobalFilter: false,
        enableDensityToggle: false,
        enableHiding: false,
        enableBottomToolbar: false,
        enableTopToolbar: false,
        enableFullScreenToggle: false,
        enableColumnResizing: false,
        enableToolbarInternalActions: false,
        initialState: {
            columnPinning: {
                left: [],
                right: [],
            },
        },
        muiTableContainerProps: {
            sx: {
                height: '100%',
            },
        },
        muiTablePaperProps: {
            sx: {
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            },
        },
        muiTableBodyProps: {
            sx: {
                padding: 0,
                margin: 0,
            },
        },
    };

    const table = useMaterialReactTable(tableOptions);

    return (
        <div className='fixed top-0 bottom-0 left-0 right-0 px-8 w-full h-full bg-white z-[999] overflow-hidden'>
            <div className='flex flex-col gap-4 w-full h-full'>
                <div className="w-full mt-4">
                    <button className="text-blue-600 font-medium flex items-center" onClick={onClose}>
                        <ArrowBack className="mr-1" /> Back
                    </button>
                </div>
                <div className=' w-full flex lg:flex-row md:flex-row flex-col justify-between gap-4 xs:flex-col items-start'>
                    <div className="max-w-max">
                        <div className="dashboard-header-left">
                            <div className="flex flex-col items-start">
                                <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight='36px'>
                                    {data?.reportName}
                                </Typography>
                                <Typography variant="subtitle1" fontSize={16} fontWeight={400} lineHeight='24px'>
                                    {data?.reportDescription}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
                <MaterialReactTable
                    table={table}
                />
            </div>
        </div>
    );
}

